import { render } from "./CookieNotice.vue?vue&type=template&id=35c5fbb4&scoped=true&ts=true"
import script from "./CookieNotice.vue?vue&type=script&lang=ts"
export * from "./CookieNotice.vue?vue&type=script&lang=ts"

import "./CookieNotice.vue?vue&type=style&index=0&id=35c5fbb4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35c5fbb4"]])

export default __exports__